module.exports = __webpack_public_path__ + "img/store.dd99effa.png";